import { render, staticRenderFns } from "./OrderShipmentTrackingNumber.vue?vue&type=template&id=39590a54&"
import script from "./OrderShipmentTrackingNumber.vue?vue&type=script&lang=ts&"
export * from "./OrderShipmentTrackingNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports